import cx from 'classnames';
import React from 'react';
import styles from './side-navigation.module.scss';
export const SideNavigation = ({ children, className = '', ...restProps }) => {
    return (React.createElement("div", { className: cx(styles.sideNavWrapper, className), ...restProps }, children));
};
//# sourceMappingURL=side-navigation.js.map